import ProcessingFeeRateMissingModal from './ProcessingFeeRateMissingModal';

export default {
  ProcessingFeeRateMissingModal,
};
